import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';

import { SortModalDialogData, SortModalComponent } from './sort-modal.component';

@Injectable({
  providedIn: 'any',
})
export class SortModalDialogService {
  constructor(private dialogService: DialogService) {}

  public open(data: SortModalDialogData): void {
    this.dialogService.open({
      component: SortModalComponent,
      matDialogConfig: {
        backdropClass: 'mode-sort-modal-backdrop',
        data,
      },
    });
  }
}
